export enum ClaimsPageState {
  CLAIM_DELETED,
}

export enum TreatmentPeriod {
  LAST_WEEK = 'LAST_WEEK',
  LAST_30_DAYS = 'LAST_30_DAYS',
  THIS_POLICY_YEAR = 'THIS_POLICY_YEAR',
  LAST_POLICY_YEAR = 'LAST_POLICY_YEAR',
}
